module.exports = "/_next/static/images/022d306376fb7418f72decf3e77fb7c0-perks-15x.jpg";